export default __webpack_public_path__ + "static/media/image-zx9.7f5d920c.jpg";